import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSubcontractorRecordsData } from 'scenes/WorkDemo/services/getSubcontractorRecordsData.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadSubcontractorRecordsData = createAsyncThunk(
  'workCalendar/loadSubcontractorRecordsData',
  async (_, { getState }) => {
    const { workSearchParams_demo } = getState();

    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const fromDate = workSearchParams_demo.fromDate;
    const toDate = workSearchParams_demo.toDate;

    const response = await getSubcontractorRecordsData(
      selectedProjectId,
      fromDate,
      toDate,
      activeEmployerInfo
    );

    return response;
  }
);
